import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import Loader from 'react-loader-spinner';

import { GET_PROGRAMS } from 'apollo/queries';
import { useAuthQuery, useFormInput } from 'utils/hooks';
import { useRedirectByRole } from 'utils/hooks/useRedirectByRole';
import { ROUTES, ROLES } from 'utils/constants';

import LeftMenu from 'components/LeftMenu';
import Header from 'components/Header';
import SearchFilter from 'components/SearchFilter';
import SolidButton from 'components/SolidButton';
import ProgramsList from 'components/programs/ProgramsList';
import NoProgramsFound from 'components/Forms/NoFormsFound';
import { NoMembers } from 'components/EmptyState';

import noTemplates from 'assets/images/no-data.svg';

const Programs = () => {
  useRedirectByRole([ROLES.SUPER_CLINIC]);
  const { t } = useTranslation();
  const { push } = useHistory();

  const { loading, data, refetch } = useAuthQuery(GET_PROGRAMS);
  const { programs: allPrograms = [] } = { ...data };

  const [programs, setPrograms] = useState([]);

  const searchPrograms = useFormInput('');
  const { value = '' } = { ...searchPrograms };

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    let temporal = allPrograms;
    if (value) {
      temporal = allPrograms.filter((program) => {
        const { title, doctorName } = { ...program };
        return `${title}-${doctorName}`.toLowerCase().includes(value.toLowerCase());
      });
    }
    setPrograms(temporal);
  }, [allPrograms, value]);

  const handleChangeRoute = () => {
    push(ROUTES.CREATE_PROGRAM);
  };

  return (
    <>
      <section className="d-flex">
        <LeftMenu />
        <div className="dashboard__main">
          <Header title={t('leftMenuHeader.programs')} shadow />
          <div className="dashboard__content--patients">
            {!loading && isEmpty(allPrograms) && (
              <NoMembers
                title="¡Aún no tienes programas configurados!"
                subtitle="Inicia configurando un programa para la valoración de tus pacientes."
                button="Crear Programa"
                handleClick={handleChangeRoute}
                image={noTemplates}
              />
            )}
            {!loading && !isEmpty(allPrograms) && (
              <div className="forms">
                <div className="forms__search">
                  <SearchFilter searchItems={searchPrograms} placeholder={t('searchLabel.program')} />
                  <SolidButton onClick={handleChangeRoute} className="slim">
                    {t('programs.button')}
                  </SolidButton>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '20%' }}>{t('tableHeader.image')}</th>
                      <th style={{ width: '30%' }}>{t('tableHeader.title')}</th>
                      <th style={{ width: '30%' }}>{t('tableHeader.doctor')}</th>
                      <th style={{ width: '10%' }}>{t('tableHeader.duration')}</th>
                      <th style={{ width: '10%' }}> </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ProgramsList programs={programs} />
                    {isEmpty(programs) && <NoProgramsFound />}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </section>
      <Loader className="spinner" type="ThreeDots" color="#495fd7" height={100} width={100} visible={loading} />
    </>
  );
};

export default Programs;
